module.exports = __webpack_public_path__ + "static/media/check-double.1ddee5f8.svg";